import { useEffect, useState } from 'react';
import { VaultOrgConfirmationSubmitAuditEntry } from '../types';
import { getOrgConfirmationLogs } from '../../../services/vault/auditLogs';

export default function useOrgConfirmationLogs({ orgId }: { orgId: string }): {
  logs: VaultOrgConfirmationSubmitAuditEntry[];
  isLoading: boolean;
} {
  const [logs, setLogs] = useState<VaultOrgConfirmationSubmitAuditEntry[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function gatherData(): Promise<void> {
      if (!isLoading) {
        return;
      }
      const retrievedLogs = await getOrgConfirmationLogs(orgId);
      setLogs(retrievedLogs);
      setIsLoading(false);
    }
    gatherData();
  });
  return { logs, isLoading };
}
